export const PROFILE_PAGE_SETUP = Object.freeze({
  ARTIST: {
    kind: "artist",
    pagesKey: "artistPages",
    basePath: "/artists",
    titleKey: "profileArtistPagesTitle",
    descriptionKey: "profileArtistPagesDescription",
    createKey: "profileCreateArtistPage",
  },
  VENUE: {
    kind: "venue",
    pagesKey: "venuePages",
    basePath: "/venues",
    titleKey: "profileVenuePagesTitle",
    descriptionKey: "profileVenuePagesDescription",
    createKey: "profileCreateVenuePage",
  },
  STUDIO: {
    kind: "studio",
    pagesKey: "studioPages",
    basePath: "/studios",
    titleKey: "profileStudioPagesTitle",
    descriptionKey: "profileStudioPagesDescription",
    createKey: "profileCreateStudioPage",
  },
  MEDIA: {
    kind: "media",
    pagesKey: "mediaPages",
    basePath: "/media",
    titleKey: "profileMediaPagesTitle",
    descriptionKey: "profileMediaPagesDescription",
    createKey: "profileCreateMediaPage",
  },
});

export function managesPage(profile, pagesKey, pageId) {
  if (!profile || !pageId || !Array.isArray(profile[pagesKey])) return false;
  return profile[pagesKey].some((page) => String(page.id) === String(pageId));
}
